// extracted by mini-css-extract-plugin
export default {"dataDescription":"G4KpZvxvkXPWMcu1nOP5__dataDescription___"};